import type { ReactNode } from "react";

interface TagProps {
  children: ReactNode;
  tone?: "primary" | "accent" | "secondary" | "muted";
}

const toneMap: Record<string, string> = {
  primary: "bg-primary-100 text-primary-800 border-primary-200",
  accent: "bg-accent-100 text-accent-800 border-accent-200",
  secondary: "bg-secondary-100 text-secondary-800 border-secondary-200",
  muted: "bg-background-100 text-foreground-600 border-background-300",
};

export default function Tag({ children, tone = "secondary" }: TagProps) {
  return (
    <span
      className={`inline-flex items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium ${toneMap[tone]}`}
    >
      {children}
    </span>
  );
}